// Runtime Environment Configuration
// Diese Funktion liest Environment-Variablen zur Laufzeit aus window.__ENV__ 
// (gesetzt vom Docker entrypoint script) oder fällt auf process.env zurück

interface RuntimeEnv {
  REACT_APP_API_URL: string;
  REACT_APP_AUTHENTIK_URL: string;
  REACT_APP_AUTHENTIK_CLIENT_ID: string;
  REACT_APP_AUTHENTIK_APPLICATION_SLUG: string;
}

// Erweitere das Window Interface für TypeScript
declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

export const getRuntimeEnv = (key: keyof RuntimeEnv): string => {
  // Versuche zuerst Runtime-Config (Docker Container)
  const runtimeValue = window.__ENV__?.[key];
  if (runtimeValue) {
    console.log(`🔧 Runtime env: ${key} = ${runtimeValue}`);
    return runtimeValue;
  }
  
  // Fallback auf Build-Zeit Environment-Variablen (lokale Entwicklung)
  const buildTimeValue = process.env[key];
  if (buildTimeValue) {
    console.log(`🔧 Build-time env: ${key} = ${buildTimeValue}`);
    return buildTimeValue;
  }
  
  // Letzte Fallback-Werte
  const defaults: RuntimeEnv = {
    REACT_APP_API_URL: 'http://localhost:5001/api',
    REACT_APP_AUTHENTIK_URL: 'https://auth.poettker-holtrup.de',
    REACT_APP_AUTHENTIK_CLIENT_ID: 'bi6FPD32tXc3cYSMKYJzFxNZbz3DeoSfnrXQPFpp',
    REACT_APP_AUTHENTIK_APPLICATION_SLUG: 'telefonbuch'
  };
  
  const defaultValue = defaults[key];
  console.warn(`⚠️  ${key} nicht gefunden - verwende Default: ${defaultValue}`);
  return defaultValue;
};

// Hilfsfunktionen für spezifische Environment-Variablen
export const getApiUrl = (): string => getRuntimeEnv('REACT_APP_API_URL');
export const getAuthentikUrl = (): string => getRuntimeEnv('REACT_APP_AUTHENTIK_URL');
export const getAuthentikClientId = (): string => getRuntimeEnv('REACT_APP_AUTHENTIK_CLIENT_ID');
export const getAuthentikApplicationSlug = (): string => getRuntimeEnv('REACT_APP_AUTHENTIK_APPLICATION_SLUG');

// Debug-Funktion für Logging
export const logEnvironmentConfig = (): void => {
  console.log('🔧 Environment Configuration:');
  console.log('   Runtime Config Available:', !!window.__ENV__);
  console.log('   API URL:', getApiUrl());
  console.log('   Authentik URL:', getAuthentikUrl());
  console.log('   Client ID:', getAuthentikClientId());
  console.log('   Application Slug:', getAuthentikApplicationSlug());
  
  if (window.__ENV__) {
    console.log('   Runtime Values:', window.__ENV__);
  } else {
    console.log('   Using Build-time Values');
  }
};
